if (!window.__mtScriptsInitialized) {
  window.__mtScriptsInitialized = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initScramble();
    initEnvioMarqueeDrag();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animar(el) {
    var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
    var suffix = el.getAttribute('data-mt-sufijo') || '';
    if (reduced) {
      el.textContent = target + suffix;
      return;
    }
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);
      el.textContent = value + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animar(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initScramble() {
  var els = document.querySelectorAll('.mt-scramble');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  function scramble(el) {
    var final = el.textContent;
    if (reduced) return;
    var length = final.length;
    var totalFrames = 22;
    var frame = 0;
    var revealEvery = totalFrames / length;
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      el.textContent = final;
    }

    function tick() {
      if (done) return;
      var output = '';
      for (var i = 0; i < length; i++) {
        var ch = final[i];
        if (ch === ' ' || ch === '\n') {
          output += ch;
        } else if (frame / revealEvery > i) {
          output += ch;
        } else {
          output += chars[Math.floor(Math.random() * chars.length)];
        }
      }
      el.textContent = output;
      frame++;
      if (frame <= totalFrames) {
        requestAnimationFrame(tick);
      } else {
        finish();
      }
    }
    tick();
    // Salvaguarda: si la pestaña pierde foco/visibilidad a mitad de la animación,
    // requestAnimationFrame puede quedar pausado indefinidamente y dejar el texto
    // a medio revelar. Esto garantiza que el texto final siempre quede correcto.
    setTimeout(finish, 600);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) finish();
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        scramble(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initEnvioMarqueeDrag() {
  var wrap = document.querySelector('.mt-envio-gratis__marquee');
  var track = wrap && wrap.querySelector('.mt-envio-gratis__marquee-track');
  if (!wrap || !track) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var half = 0;
  var speedPxPerMs = 0;
  var offset = 0;
  var dragging = false;
  var moved = 0;
  var startX = 0;
  var startOffset = 0;
  var lastTs = null;

  function measure() {
    half = track.scrollWidth / 2;
    var durationS = parseFloat(getComputedStyle(track).animationDuration) || 22;
    speedPxPerMs = half / (durationS * 1000);
  }
  measure();
  window.addEventListener('resize', measure);

  // A partir de aquí el movimiento lo controla JS (permite arrastrar), en vez del
  // @keyframes de CSS con el que arranca la sección (que solo se mueve sola).
  track.style.animation = 'none';

  function wrapOffset(value) {
    while (value <= -half) value += half;
    while (value > 0) value -= half;
    return value;
  }

  function apply() {
    track.style.transform = 'translateX(' + offset + 'px)';
  }

  function tick(ts) {
    if (!dragging && !reduced && lastTs !== null) {
      offset = wrapOffset(offset - speedPxPerMs * (ts - lastTs));
      apply();
    }
    lastTs = ts;
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  function suppressNextClick(e) {
    e.preventDefault();
    e.stopPropagation();
    wrap.removeEventListener('click', suppressNextClick, true);
  }

  wrap.addEventListener('pointerdown', function (e) {
    dragging = true;
    moved = 0;
    startX = e.clientX;
    startOffset = offset;
    wrap.classList.add('mt-envio-gratis__marquee--dragging');
    try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
  });

  wrap.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var delta = e.clientX - startX;
    moved = Math.abs(delta);
    offset = wrapOffset(startOffset + delta);
    apply();
  });

  function endDrag() {
    if (!dragging) return;
    dragging = false;
    wrap.classList.remove('mt-envio-gratis__marquee--dragging');
    if (moved > 6) {
      wrap.addEventListener('click', suppressNextClick, true);
    }
  }
  wrap.addEventListener('pointerup', endDrag);
  wrap.addEventListener('pointercancel', endDrag);
}
